import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { SS_STEP, StepComponent } from '../step/step.component';

@Component({
  selector: 'ss-www-step-header',
  imports: [],
  templateUrl: './step-header.component.html',
  styles: `
    .circle-bg-gradient {
      background: linear-gradient(112.9deg, #cf9c51 0%, #836231 100%);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepHeaderComponent {
  private step = inject<StepComponent>(SS_STEP);

  stepperIndex = this.step.stepperIndex;
  totalSteps = this.step.totalSteps;
}
